import { Button, message, Popconfirm, Tooltip } from 'antd'
import React, { FunctionComponent, useCallback } from 'react'

import { BASE_URL } from '../../../../ini.json'
import { sanitizeFileName } from '../../../common/pdfHelpers'
import {
  Maybe,
  useDeleteBuybackCalculationMutation,
} from '../../../graphql/generated'
import { isBuybackVersionCompatible } from '../../utils/buybackConst'
import { LocalSavedPdf } from '../LocalSavedPdf/LocalSavedPdf'
import { LocalSavedPdfDrawerPreview } from '../LocalSavedPdfDrawerPreview/LocalSavedPdfDrawerPreview'

export interface BuybackRecord {
  id: string | undefined
  accountId?: string
  title?: Maybe<string>
  calculatorVersion?: Maybe<string>
}

export interface PropertyDetailBuybackHistoryTableActionProps {
  record: BuybackRecord
  onSelect: (record: BuybackRecord) => void
}

export const PropertyDetailBuybackHistoryTableAction: FunctionComponent<PropertyDetailBuybackHistoryTableActionProps> =
  ({ record, onSelect }) => {
    const { id, accountId, title, calculatorVersion } = record

    const [, deleteBuybackCalculation] = useDeleteBuybackCalculationMutation()

    const removeBuybackCalculation = useCallback(async () => {
      if (!id) return

      const result = await deleteBuybackCalculation({
        id: id,
        deletedAt: new Date(),
      })

      if (result.error) message.error('Kalkulaci se nepodařilo odebrat.')
      else message.success('Kalkulace byla odebrána.')
    }, [id, deleteBuybackCalculation])

    return (
      <div className="flex justify-end">
        <LocalSavedPdfDrawerPreview
          buttonProps={{ size: 'small', type: 'link' }}
          drawerTitle="PDF náhled kalkulace"
          fileName={sanitizeFileName(title, 'kalkulace-')}
          path={`${BASE_URL}/download/${accountId}/buyback/${id}.pdf`}
          buttonText="PDF"
        >
          <LocalSavedPdf
            path={`${BASE_URL}/download/${accountId}/buyback/${id}.pdf`}
          />
        </LocalSavedPdfDrawerPreview>

        {isBuybackVersionCompatible(calculatorVersion) ? (
          <Button onClick={() => onSelect(record)} size="small" type="link">
            Použít
          </Button>
        ) : (
          <Tooltip
            mouseEnterDelay={0.5}
            title="Kalkulace byla vytvořena ve starší verzi kalkulačky, která již není kompatibilní. PDF zůstává k dispozici."
          >
            <Button size="small" type="link" disabled>
              Použít
            </Button>
          </Tooltip>
        )}

        <Popconfirm
          title={`Opravdu chcete smazat kalkulaci "${title}"?`}
          onConfirm={removeBuybackCalculation}
          okText="Smazat"
          cancelText="Zrušit"
          okType="danger"
        >
          <Button size="small" type="link" danger>
            Smazat
          </Button>
        </Popconfirm>
      </div>
    )
  }
